import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';

import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';

const GeneralSettings = () => {

    const [selectedModule, setSelectedModule] = useState()
    const [selectedTab, setSelectedTab] = useState([])
    const [selectedSubTab, setSelectedSubTab] = useState([])
    const moduleOptions = [
        {
            label: 'ULD Control',
            value: 'ULD',
            options: [
                {
                    label: 'ULD Control', value: 'ULD',
                    sub: [
                        { label: 'Assets', value: 'assets' },
                        { label: 'Operations', value: 'operations' },
                        { label: 'On Air', value: 'onair' },
                        { label: 'Repair', value: 'repair' },
                        { label: 'On Loan', value: 'onloan' },
                        { label: 'Messages', value: 'messages' },
                    ]
                },
                {
                    label: 'History', value: 'HIS',
                    sub: [
                        { label: 'UCM', value: 'ucm' },
                        { label: 'LUC', value: 'luc' },
                        { label: 'SCM', value: 'scm' },
                        { label: 'Message Log', value: 'msg_log' },
                    ]
                },
                {
                    label: 'Recovery', value: 'REC',
                    sub: [
                        { label: 'Missing', value: 'ULD' },
                        { label: 'MVT Mismatch', value: 'RFS' },
                        { label: 'Inactive ULDs', value: 'SER' },
                        { label: 'Message Log', value: 'SER' },
                    ]
                },
                {
                    label: 'Invoice', value: 'INV',
                    sub: [
                        { label: 'Demmurrage', value: 'ULD' },
                    ]
                },
                { label: 'Flight Schedule', value: 'FLS' },
            ]
        },
        {
            label: 'RFS Control Tower',
            value: 'RFS',
            options: [
                { label: 'Dashboard', value: 'DAS' },
                { label: 'Bookingtruck Schedule', value: 'BTS' },
                { label: 'Truck Order', value: 'TRO' },
                { label: 'AWB Manager', value: 'AMG' },
                {
                    label: 'RFS Monitor', value: 'RMR',
                    sub: [
                        { label: 'Order View', value: 'orders' },
                        { label: 'AWB View', value: 'awb' },
                    ]
                },
            ]
        },
        {
            label: 'Service Recovery',
            value: 'SER',
            options: [
                { label: 'Dashboard', value: 'DAS' },
                { label: 'Overview', value: 'OVW' },
                { label: 'Inbox', value: 'INX' },
                { label: 'Task Management', value: 'TMT' },
            ]
        }
    ];

    const [formData, setFormData] = useState([]);

    const handleChange = (idx, module, selectedTab, selectedSub = null) => {
        setFormData(prev => {
            const updated = [...prev];

            updated[idx] = {
                ...updated[idx],
                module,
                tab: selectedTab?.value || '',
                sub_tab: selectedSub?.value || ''
            };

            return updated;
        });
    };
    const dropdownChange = (name, module, selectedTab, selectedSub = null) => {
        setFormData(prev => ({ ...prev, [name]: module }));
        if (name === 'module') {
            setSelectedTab(selectedTab.sub)
        } else if(name === 'tab') {
            setSelectedSubTab(selectedTab.sub)
        }
    };

    return (
        <>
            {console.log('formData', formData)}
            <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right'>
                    <h4>User Preference Settings</h4>
                    <p>Manage user preferences, such as navigation & notifications.</p>
                    <hr />
                    {moduleOptions.map((mod, index) => {
                        const selectedTab = mod.options?.find(
                            opt => opt.value === formData[index]?.tab
                        );
                        // console.log('selectedTab', selectedTab)
                        return (
                            <div key={`mod_${index}`} className='d-flex align-items-center mt-3'>
                                <div className='me-3'>
                                    <h4>{mod.label}</h4>
                                </div>
                                <div style={{ width: '200px' }} className='me-2'>
                                    <Select
                                        options={mod.options}
                                        onChange={(selected) => handleChange(index, mod.value, selected)}
                                        placeholder="Tab Preference" className="rfs_autoslct" name="tab"
                                        value={selectedTab || null}
                                    />
                                </div>
                                {selectedTab?.sub &&
                                    <div style={{ width: '200px' }}>
                                        <Select
                                            options={selectedTab.sub}
                                            onChange={(selected) => handleChange(index, mod.value, selectedTab, selected)}
                                            placeholder="Tab Preference" className="rfs_autoslct" name="tab"
                                            value={selectedTab.sub.find(s => s.value === formData[index]?.sub_tab) || null}
                                        />
                                    </div>
                                }
                            </div>
                        )
                    })}
                    {/* <div className='d-flex align-items-center mt-3'>

                        <div style={{ width: '200px' }} className='me-2'>
                            <Select
                                options={moduleOptions}
                                onChange={(selected) => dropdownChange('module', selected.value, selected)}
                                placeholder="Module Preference" className="rfs_autoslct" name="tab"
                                value={moduleOptions.find(item => item.value === formData.module) || null}
                            />
                        </div>
                        {selectedTab?.length ?
                            <div style={{ width: '200px' }} className='me-2'>
                                <Select
                                    options={selectedTab}
                                    onChange={(selected) => dropdownChange('tab', selected.value, selected)}
                                    placeholder="Tab Preference" className="rfs_autoslct" name="tab"
                                    value={selectedTab?.find(s => s.value === formData?.tab) || null}
                                />
                            </div>
                            : <></>
                        }
                        {selectedSubTab.length ?
                            <div style={{ width: '200px' }} className='me-2'>
                                <Select
                                    options={selectedSubTab}
                                    onChange={(selected) => dropdownChange('sub_tab', selected.value, selected)}
                                    placeholder="Tab Preference" className="rfs_autoslct" name="tab"
                                    value={selectedSubTab?.find(s => s.value === formData?.sub_tab) || null}
                                />
                            </div>
                            : <></>
                        }
                    </div> */}
                    {/* <div className='d-flex align-items-center mt-3'>
                        <div className='me-3'>
                            <h4>ULD Control</h4>
                        </div>
                        <div style={{ width: '200px' }}>
                            <Select
                                options={ULDOptions}
                                onChange={(selected) => handleChange("tab_preferences", selected ? selected.value : "")}
                                placeholder="Tab Preference" className="rfs_autoslct" name="tab"
                                value={ULDOptions.find((option) => option.value == formData.tab_preferences) || null}
                            />
                        </div>
                    </div>
                    <div className='d-flex align-items-center mt-3'>
                        <div className='me-3'>
                            <h4>RFS Control Tower</h4>
                        </div>
                        <div style={{ width: '200px' }}>
                            <Select
                                options={RFSOptions}
                                onChange={(selected) => handleChange("tab_preferences", selected ? selected.value : "")}
                                placeholder="Tab Preference" className="rfs_autoslct" name="tab"
                                value={RFSOptions.find((option) => option.value == formData.tab_preferences) || null}
                            />
                        </div>
                    </div>
                    <div className='d-flex align-items-center mt-3'>
                        <div className='me-3'>
                            <h4>Service Recovery</h4>
                        </div>
                        <div style={{ width: '200px' }}>
                            <Select
                                options={SEROptions}
                                onChange={(selected) => handleChange("tab_preferences", selected ? selected.value : "")}
                                placeholder="Tab Preference" className="rfs_autoslct" name="tab"
                                value={SEROptions.find((option) => option.value == formData.tab_preferences) || null}
                            />
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default GeneralSettings